export const contextColors = {
  unistocks: 'rgb(0, 161, 224)',
  unistocksAlt: 'rgb(0, 83, 116)',

  bodyFont: 'rgb(23, 23, 23)',
  headingFont: 'rgb(0, 83, 116)',

  success: 'rgb(25, 135, 84)',
  danger: 'rgb(220, 53, 69)',
  info: 'rgb(23, 162, 184)',
  warning: 'rgb(255, 193, 7)',

  positive: 'rgb(0, 159, 223)',
  negative: 'rgb(255, 0, 0)'
};
